import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";

import "swiper/swiper-bundle.css";
import "normalize.css";
import "./assets/styles/index.scss";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UIProvider } from "./storage/hooks/UIHooks";
import { initAppProperties } from './storage/app-properties'

initAppProperties();

ReactDOM.render(
  <HashRouter basename="/">
    <UIProvider>
      <App />
    </UIProvider>
  </HashRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
